module.exports = __webpack_public_path__ + "img/11.964cf39f.jpg";